import { render, staticRenderFns } from "./PasteUploadDia.vue?vue&type=template&id=1c742a30&scoped=true"
import script from "./PasteUploadDia.vue?vue&type=script&lang=js"
export * from "./PasteUploadDia.vue?vue&type=script&lang=js"
import style0 from "./PasteUploadDia.vue?vue&type=style&index=0&id=1c742a30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c742a30",
  null
  
)

export default component.exports